module.exports = __webpack_public_path__ + "static/media/login_bgn.891733f4.png";